export const GET_USERS = 'GET_USERS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const GET_USER = 'GET_USER';
export const GET_REPOS = 'GET_REPOS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const SET_ALERT = 'SET_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const SET_LOADING = 'SET_LOADING';